<template>
    <div class="row justify-content-center">
        <div class="col-lg-8 col-xl-6">
            <StepsPercentage percentage="width:95%;" outerClass="mb-4" />

            <div class="card bg-white">
                <div class="card-body border-0">
                    <div v-if="chatLoading" :class="!chatLoading ? 'faded' : ''" class="chat-help d-flex align-items-center mb-4">
                        <div class="chat-help-avatar">
                            <img src="/images/chat-help-image.jpg" class="rounded-circle">
                        </div>
                        <div class="chat-help-bubble ml-3">
                                I'm just checking your elligibility now...
                        </div>
                    </div>

                    <div class="chat-help d-flex align-items-center mb-4">
                        <div class="chat-help-avatar">
                            <img src="/images/chat-help-image.jpg" class="rounded-circle">
                        </div>
                        <div class="chat-help-bubble ml-3">

                            <div v-if="chatLoading" class="my-2">
                                <div class="dots">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                            <div v-else>
                                Congratulations you're elligible to make a request, to finish up please enter your email address
                            </div>

                            
                        </div>
                    </div>
        
                    <form v-if="!chatLoading" @submit.prevent="validateBeforeSubmit">
                        <fieldset class="mb-2">
                            <BasicInput
                                label="What's your email?"
                                id="email"
                                name="email"
                                type="email"
                                v-model="email"
                                :exval="validationAttempt"
                                v-validate="'required|email'"
                                :error="errors.first('email')"
                            />
                        </fieldset>

                        <div class="light txt-grey p14 my-5" style="max-width: 470px;">By submitting your information, you agree to the terms of our <a href="/legal/privacy" target="_blank">Privacy Policy</a>, <a href="/legal/tos" target="_blank">Terms of Use</a> and <a href="/legal/disclaimer" target="_blank">Disclaimer</a>.</div>

                        <div class="d-flex align-items-center">
                            <button class="btn btn-cta btn-red uc" id="form-submit">{{saving ? 'Saving...' : 'Submit'}}</button>
                            <div>
                                <transition name="slide">
                                    <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                                </transition>
                            </div>
                        </div>
                    </form>
                </div><!--End Card Body-->
            </div><!--End Card-->
        </div><!--End Col-->
    </div><!--End Row-->
</template>

<script>
import axios from 'axios';
import BasicInput from '@/components/form/BasicInput.vue';
import StepsPercentage from '@/components/form/StepsPercentage.vue';

import { mapGetters, mapActions } from "vuex";

export default {
    name: 'WizardStep6',
    title: 'Apply | Step 6',
    components:{
        BasicInput,
        StepsPercentage
    },
    data() {
	  return {
            validationAttempt: false,
            saving: false,
            chatLoading: true,

			email: '',
		}
    },
    methods: {
        ...mapActions(['saveFormData', 'recogniseUser']),
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
                        'email': this.email.toLowerCase(),
						'step6': true,
                    });
                    this.$router.push({ path: '/apply/sending' });
                    return;
                }

                this.saving = false;
				
      		});
        },
    },
    computed: {
        ...mapGetters(["formData"]),
    },
    created(){
        setTimeout(() => {
            this.chatLoading = false;
        }, 3000);
        this.email = this.formData.email || '';
  }
}
</script>